import { ApiThumbnail } from "src/types/ApiThumbnail";

import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Button, Figure, Modal } from "react-bootstrap";
import constants from "src/constants";
import Small_cancel from "src/icons/Small-cancel";
import { sModal } from "src/styles/sModal.module.scss";
import { sModalImage } from "src/styles/sModalImage.module.scss";

type Props = {
  data: ApiThumbnail;
  className?: (string | string) | null | undefined;
  close: () => void;
};

function ModalImage({ data, className, close }: Props) {
  const { locale: lang } = useRouter();
  var imageLarge = data.url
    ? ifDefined(
        data.formats,
        (value) =>
          data.formats.large
            ? constants.Paths.imagesUrl + data.formats.large.url
            : constants.Paths.imagesUrl + data.url,
        () => constants.Paths.imagesUrl + data.url
      )
    : null;
  return data ? (
    <Modal
      show={true}
      className={composeClassNames([
        sModal,
        sModalImage,
        className,
        "modal-image",
      ])}
      size={`lg`}
      dialogClassName={`modal-dialog`}
      onHide={close}
    >
      <Modal.Body>
        <Button
          variant={`link`}
          onClick={function () {
            return close();
          }}
          size={`sm`}
          className={`btn-close`}
        >
          <Small_cancel />
        </Button>
        {data.url.length > 0 ? (
          <Figure>
            <Figure.Image src={imageLarge} alt={data.alternativeText} />
          </Figure>
        ) : null}
      </Modal.Body>
    </Modal>
  ) : null;
}

export default ModalImage;
